import LiveSubscriberComponent from "./LiveSubscriberComponent";

export default LiveSubscriberComponent;